/**
 * Browser identification utility
 * Generates and manages a unique browser identifier for cart isolation
 */

const BROWSER_ID_KEY = 'temple_browser_id';

/**
 * Generate a UUID v4
 * @returns {string} UUID string
 */
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * Get or create browser ID
 * This ensures each browser has a unique identifier for cart isolation
 * @returns {string} Browser ID
 */
export function getBrowserId() {
  try {
    // Try to get existing browser ID from localStorage
    let browserId = localStorage.getItem(BROWSER_ID_KEY);

    // If no browser ID exists, generate a new one
    if (!browserId) {
      browserId = generateUUID();
      localStorage.setItem(BROWSER_ID_KEY, browserId);
      console.log('Generated new browser ID:', browserId);
    } else {
      console.log('Using existing browser ID:', browserId);
    }

    return browserId;
  } catch (error) {
    console.error('Error accessing localStorage for browser ID:', error);
    // Fallback to session-based ID if localStorage is not available
    if (!window._tempBrowserId) {
      window._tempBrowserId = generateUUID();
    }
    return window._tempBrowserId;
  }
}

/**
 * Clear browser ID (useful for testing or logout scenarios if needed)
 */
export function clearBrowserId() {
  try {
    localStorage.removeItem(BROWSER_ID_KEY);
    delete window._tempBrowserId;
    console.log('Browser ID cleared');
  } catch (error) {
    console.error('Error clearing browser ID:', error);
  }
}

/**
 * Initialize browser ID on app load
 * Call this early in the application lifecycle
 */
export function initializeBrowserId() {
  const browserId = getBrowserId();
  console.log('Browser initialized with ID:', browserId);
  return browserId;
}

// Auto-initialize browser ID immediately when this module loads
// This ensures browser_id is available before any API calls
initializeBrowserId();
